// extracted by mini-css-extract-plugin
export default {"card":"_0aYKV0G1--Card_card__zQfcO","cardClickable":"_0aYKV0G1--Card_cardClickable__rCKfH","wiggle":"_0aYKV0G1--Card_wiggle__eIbcU","shimmer":"_0aYKV0G1--Card_shimmer__HQrum"};